import { FC } from "react"
import { useTranslation } from "react-i18next"
import { ZoomIn } from "@mui/icons-material"
import { PRIMARY_BLUE } from "utils/customizedTheme"
import { useGET_studentAssignmentsQuery } from "redux/api/assignmentsApi"
import { useNavigate } from "react-router-dom"

const SectionBigMyWork: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data } = useGET_studentAssignmentsQuery({
    page: 1, page_size: 12
  })

  return (
      <>
        <div className='grid-3'>
            {data?.results?.map((a) => <div key={a.id} style={{ width: '200px' }}>

                <div className='grid-3-item'
                    onClick={() => {
                       navigate(`/student-assignments/edit/${a.id}`)
                    }}
                    >
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        fontSize: '18px', 
                        fontWeight: '500', 
                        paddingBottom: '10px', 
                        cursor: 'pointer',
                        textAlign: 'center' }}>
                        <ZoomIn sx={{ color: PRIMARY_BLUE, marginRight: '5px' }}/>
                        {a.title}
                      </div>
                    </div>
            </div>)}   
        </div>


     
    </>
  )
}

export default SectionBigMyWork
